/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { GetV1UsersUserSettingsQueryResponse } from "../../../types/GetV1UsersUserSettings.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getGetV1UsersUserSettingsUrlClient() {
  const res = { method: 'GET', url: `/v1/users/user_settings` as const }
  return res
}

/**
 * @summary Get user settings
 * {@link /v1/users/user_settings}
 */
export async function getV1UsersUserSettingsClient(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetV1UsersUserSettingsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetV1UsersUserSettingsUrlClient().url.toString(), ... requestConfig })
  return res
}